/**
 * don't copy this implementation
 * we use a single source of state without provider
 * to make this context "global"
 */

import hash from "@emotion/hash"
import { createContext, useContext } from "react"

export const ctx__ONLY_FOR_HEADER__ = {
  cssVars: new Proxy(
    {},
    {
      get: (t, p) => {
        console.trace("header<old> cssVars", p)
        throw new Error()
      },
    }
  ),
  get ref() {
    console.trace("header<old> ref")
    throw new Error()
  },
  events: new Proxy(
    {},
    {
      get: (t, p) => {
        console.trace("header<old> events", p)
        throw new Error()
      },
    }
  ),
  expansion: () => {
    console.trace("header<old> expansion")
    throw new Error()
  },
  lock: () => {
    console.trace("header<old> lock")
    throw new Error()
  },
  unlock: () => {
    console.trace("header<old> unlock")
    throw new Error()
  },
  forceUnlock: () => {
    console.trace("header<old> forceUnlock")
    throw new Error()
  },
  freeze: () => {
    console.trace("header<old> freeze")
    throw new Error()
  },
  unfreeze: () => {
    console.trace("header<old> unfreeze")
    throw new Error()
  },
}
const Context = createContext(ctx__ONLY_FOR_HEADER__)
export const Provider = ({ children }) => children

export function useHeader() {
  console.trace("header<old> useHeader")
  return useContext(Context)
}

export const cssVarExpansion = `--${hash("header:expansion")}`
export const cssVarFocusIn = `--${hash("header:focus:in")}`
export const cssVarHeight = "--header-height" //`--${hash("header:height")}`
export const cssVarCurBanHeight = `--${hash("curban:height")}`
export const cssVarTransitionDuration = `--${hash("header:transition:duration")}`
export const cssVarTransitionDelay = `--${hash("header:transition:delay")}`

export const cssVarFreeze = `--${hash("header:freeze")}`
export const cssVarHideSubNav = `--${hash("header:subNav:hidden")}`
